import { render } from "./BaseDocumentReport.vue?vue&type=template&id=1a3d95dc"
import script from "./BaseDocumentReport.vue?vue&type=script&lang=js"
export * from "./BaseDocumentReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__